import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { MatTableDataSource } from '@angular/material/table';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { ModulePopupComponent } from 'src/app/dcon-modules/config-workbook-compare/module-popup/module-popup.component';


export interface ExampleTab {
  label: string;
  content: string;
}


@Component({
  selector: 'app-config-workbook-home',
  templateUrl: './config-workbook-home.component.html',
  styleUrls: ['./config-workbook-home.component.scss']
})
export class ConfigWorkbookHomeComponent implements OnInit {
  public batchKey: string;
  public loader: boolean;
  public batchStatus: any;
  public createWorkbookData: any = [];
  public compareWorkbookData: any = [];
  public dataValue: [] = [];
  public dateFormat: any;
  dataSourceWorkBook: any = new MatTableDataSource();
  dataSourceConfigWorkBook: any = new MatTableDataSource();
  filterSelectObj = [];
  emptyTable: boolean = false;
  pageIndex = 0;
  size = 5;
  p: any = 1;
  p1: any = 1;
  tableData1: any;
  tableData: any;
  filterSelectObjForWorkbook = [];
  public workbookNewBtnDisable: boolean = true;
  public searchNewBtnDisable: boolean = true;
  items = [];
  pageOfItems: Array<any>;
  loadToCloudData: any = [];
  filteredValue;
  filterValues = {};
  filterValues1 = {};
  public searchText;
  public searchText1;
  isTrainStopUrl: boolean;
  legacyBatchKeys: any = [];
  extractFromCloudData: any = [];
  extractionBatchKeys: any = [];
  projectId: string;
  queryParams: any;
  isChecked: boolean = false;
  downloadDropdown: number;
  emptyTable1: boolean = false;
  selected: any = [];
  hideme: number;
  showMenu: boolean = false;
  refresh: boolean = true;
  extractRefresh: boolean = true;
  failedToFetchWorkbooks: boolean = false;
  failedToFetchBatchKeys: boolean = false;
  noWorkbooksCreated: boolean = false;
  noExtractsFound: boolean = false;
  displayedColumns: string[] = ['check_box', 'batch_key', 'extract_source', 'date', 'action'];
  displayedColumnsForWorkbook: string[] = ['batch_key', 'date', 'workbook_status', 'action'];
  constructor(private router: Router,
    public dialog: MatDialog,
    private celService: CompareserviceService,
    private _data: DataService,
    private route: ActivatedRoute,
    private notification: NotificationService,
    private cd: ChangeDetectorRef) {
    this.isTrainStopUrl = this.celService.getisTrainStopUrl();
    this.filterSelectObj = [
      {
        name: 'Extract Source',
        columnProp: 'source_type',
        options: []
      }
    ];

    this.filterSelectObjForWorkbook = [
      {
        name: 'Status',
        columnProp: 'workbook_status',
        options: []
      }
    ];
    if (this.isTrainStopUrl) {
      const obj = JSON.parse(sessionStorage.getItem('queryParams'));
      this.queryParams = obj;
    }

  }

  @ViewChild('scrollToMe') scrollToMe: ElementRef;

  ngOnInit(): void {
    const prjid = this._data.projectID;
    if (prjid == null || prjid == undefined) {
      window.location.href = DconConfigAPI.redirectUri;
    } else {
      this.onRefresh();
      this.onRefreshForWorkbook();
      this.getExtractBatchKeys();
      this.getWorkbookBatchkeys();
      this.dataSourceWorkBook.filterPredicate = this.createFilter();
      this.dataSourceConfigWorkBook.filterPredicate = this.createFilterForWorkbook();
    }
  }

  getWorkbookBatchkeys() {
    this.emptyTable1 = false;
    this.refresh = false;
    this.celService.getWorkbookBatchkeys().subscribe((res) => {
      this.refresh = true;
      if (res?.Result === "SUCCESS" && res.Batchkey_details !== undefined) {
        this.searchNewBtnDisable = false;
        !res.Batchkey_details.length ? this.noWorkbooksCreated = true : this.noWorkbooksCreated = false;
        this.extractionBatchKeys = this.getDistinctWookBooks(res.Batchkey_details);
        this.dataSourceConfigWorkBook.data = this.extractionBatchKeys;
        this.tableData1 = this.dataSourceConfigWorkBook.data;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.failedToFetchWorkbooks = false;
        this.filterSelectObjForWorkbook.filter((o) => {
          o.options = this.getFilterObject1(this.extractionBatchKeys, o.columnProp);
          o.options.splice(0, 0, "None");
        });
        this.sortDataForWorkbook();
        if (this._data.workbookCreated) {
          this.cd.detectChanges();
          this.scrollToMe.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }
        this._data.workbookCreated = false;
      } else {
        this.failedToFetchWorkbooks = true;
      }
    }, error => {
      this.refresh = true;
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.failedToFetchWorkbooks = true;
      this.notification.showError('Something went wrong!');
    });
  }

  onRefresh() {
    this.extractFromCloudData.length = 0;
    this.extractRefresh = false;
    this.emptyTable = false;
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues = {};
    this.searchText = undefined;
    this.maskPage();
    this.filterSelectObj = [
      {
        name: 'Extract Source',
        columnProp: 'source_type',
        options: []
      }
    ];
    this.dataSourceWorkBook = new MatTableDataSource();
    this.dataSourceWorkBook.filterPredicate = this.createFilter();
    this.getExtractBatchKeys();
  }

  onRefreshForWorkbook() {
    this.extractionBatchKeys.length = 0;
    this.refresh = false;
    this.emptyTable = false;
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues = {};
    this.searchText1 = undefined;
    this.maskPage();
    this.filterSelectObjForWorkbook = [
      {
        name: 'Status',
        columnProp: 'workbook_status',
        options: []
      }
    ];
    this.dataSourceConfigWorkBook = new MatTableDataSource();
    this.dataSourceConfigWorkBook.filterPredicate = this.createFilter();
    this.getWorkbookBatchkeys();

  }
  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  getDistinctBatchKeys(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      const item = {
        "batch_key": curr.batch_key,
        "creation_date": curr.creation_date,
        "extract_status": curr.extract_status,
        "source_type": curr.source_type,
        module: []
      };
      const task_list = [curr.task_name];
      const currModule = {
        "application": curr.application,
        "task_list": task_list,
      };
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = item;
        obj[curr.batch_key].module.push(currModule);
      } else {
        //same batch && new module
        if (!obj[curr.batch_key].module
          .find(e => e.application === curr.application)) {
          obj[curr.batch_key].module.push(currModule);
        } else {
          //same batch && same module
          obj[curr.batch_key].module.map(e => {
            if (e.application === curr.application) {
              e.task_list.push(curr.task_name);
            }
          });
        }
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }

  getDistinctWookBooks(res) {
    const distinctBatchKeys = res
      .filter(e => e.workbook_status !== 'New')
      .reduce((obj, curr) => {

        let success_count = 0;
        const total_count = 1;
        let ErrorModule;
        let success_path = '';
        const success_files = [];
        if (curr.output_file_path && (curr.output_file_path).includes('\\OUT\\')) {
          success_count++;
          success_path = curr.output_file_path;
          success_files.push(curr.output_file_path);
        } else {
          ErrorModule = {
            "application": "Error",
            "fileList": [curr.output_file_path],
            "output_file_path": curr.output_file_path,
            "success_count": 0,
            "total_count": 0
          };
        }
        const task_list = [curr.task_name];
        const currModule = {
          "application": curr.application,
          "fileList": success_files,
          "output_file_path": success_path,
          "success_count": success_count,
          "total_count": total_count,
          "task_list": task_list
        };
        const item = {
          "batch_key": curr.batch_key,
          "creation_date": curr.creation_date,
          "workbook_status": curr.workbook_status,
          module: []
        };
        if (!obj[curr.batch_key]) {
          obj[curr.batch_key] = item;
          obj[curr.batch_key].module.push(currModule);
          //if error module then push it
          if (ErrorModule) {
            obj[curr.batch_key].module.push(ErrorModule);
          }
        } else {
          //same batch && new module
          if (!obj[curr.batch_key].module
            .find(e => e.application === curr.application)) {
            if (obj[curr.batch_key].module.length &&
              obj[curr.batch_key].module.find(e => e.application === "Error")) {
              obj[curr.batch_key].module.splice(
                obj[curr.batch_key].module
                  .findIndex((e) => e.application === "Error"), 0, currModule);
            } else {
              obj[curr.batch_key].module.push(currModule);
            }
          } else {
            //same batch && same module
            obj[curr.batch_key].module.map(e => {
              if (e.application === curr.application && !e.task_list.includes(curr.task_name)) {

                e.total_count += 1;

                if (curr.output_file_path
                  && (curr.output_file_path).includes('\\OUT\\')) {
                  e.success_count += 1;
                  e.output_file_path = curr.output_file_path;

                  if (!(e.fileList).includes(curr.output_file_path)) {
                    e.fileList.push(curr.output_file_path);
                  }
                }
                e.task_list.push(curr.task_name);
              }
              return e;
            });
          }

          //same batch push error module if not available
          if (ErrorModule && !obj[curr.batch_key].module
            .find(e => e.application === 'Error')) {
            obj[curr.batch_key].module.push(ErrorModule);
          }
        }
        obj[curr.batch_key].downloadAll = false;
        obj[curr.batch_key].module.map(e => {
          // if(e.success_count > 0 && obj[curr.batch_key].module.length > 1) {
          if(e.success_count > 0 ) {
            if(obj[curr.batch_key].module.length > 1) {
              obj[curr.batch_key].downloadAll = true;
          }
        }
        });
        return obj;
      }, Object.create(null));

    return Object.values(distinctBatchKeys);

  }

  getExtractBatchKeys() {
    this.emptyTable = false;
    this.extractRefresh = false;
    this.loader = true;
    this.celService.getExtractBatchKeys().subscribe((res) => {
      this.extractRefresh = true;
      if (res?.Result === "SUCCESS" && res.Batch_key_details !== undefined) {
        this.searchNewBtnDisable = false;
        !res.Batch_key_details.length ? this.noExtractsFound = true : this.noExtractsFound = false;
        this.extractFromCloudData = this.getDistinctBatchKeys(res.Batch_key_details);//res.Batch_key_details;
        this.dataSourceWorkBook.data = this.extractFromCloudData;
        this.tableData = this.dataSourceWorkBook.data;
        this._data.apiCallInProgress = false;
        this.failedToFetchBatchKeys = false;
        document.getElementById("overlay").style.display = "none";
        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.extractFromCloudData, o.columnProp);
          o.options.splice(0, 0, "None");
        });


        this.sortData();
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

      } else {
        this.failedToFetchBatchKeys = true;
      }

    }, error => {
      this.extractRefresh = true;
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.failedToFetchBatchKeys = true;
      this.notification.showError('Something went wrong!');
    });

  }

  search(value: string): void {
    if (value == null || value == undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    const serchText = value.toUpperCase();
    this.dataSourceWorkBook.data = this.extractFromCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText));
    this.tableData = this.dataSourceWorkBook.filteredData;

    if (this.extractFromCloudData.some(item => item.batch_key === value) || value == "") {
      this.emptyTable = false;
      this.filterValues = {};
      this.searchText = undefined;
      this.filterSelectObj = [
        {
          name: 'Extract Source',
          columnProp: 'source_type',
          options: []
        }
      ];
      this.filterSelectObj.filter((o) => {
        o.options = this.getFilterObject(this.extractFromCloudData, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceWorkBook = new MatTableDataSource();
      this.dataSourceWorkBook.filterPredicate = this.createFilter();
      this.dataSourceWorkBook.data = this.extractFromCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText));
      this.dataSourceWorkBook.filter = JSON.stringify(this.filterValues);
      this.tableData = this.dataSourceWorkBook.filteredData;
    } else {
      this.emptyTable = true;
    }
  }

  searchForWorkbook(value: string): void {
    if (value == null || value == undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p1 = 1;
    const searchText1 = value.toUpperCase();
    this.dataSourceConfigWorkBook.data = this.extractionBatchKeys.filter((val) => val.batch_key.toUpperCase().includes(searchText1));
    this.tableData1 = this.dataSourceConfigWorkBook.filteredData;

    if (this.extractionBatchKeys.some(item => item.batch_key === value) || value == "") {
      this.emptyTable1 = false;
      this.filterValues1 = {};
      this.searchText1 = undefined;
      this.filterSelectObjForWorkbook = [
        {
          name: 'Status',
          columnProp: 'workbook_status',
          options: []
        }
      ];
      this.filterSelectObjForWorkbook.filter((o) => {
        o.options = this.getFilterObject1(this.extractionBatchKeys, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceConfigWorkBook = new MatTableDataSource();
      this.dataSourceConfigWorkBook.filterPredicate = this.createFilterForWorkbook();
      this.dataSourceConfigWorkBook.data = this.extractionBatchKeys.filter((val) => val.batch_key.toUpperCase().includes(searchText1));
      this.dataSourceConfigWorkBook.filter = JSON.stringify(this.filterValues1);
      this.tableData1 = this.dataSourceConfigWorkBook.filteredData;
    } else {
      this.emptyTable1 = true;
    }


  }

  sortData() {
    return this.extractFromCloudData.sort((a, b) => {
      return <any>new Date(b.creation_date) - <any>new Date(a.creation_date);
    });
  }

  sortDataForWorkbook() {
    return this.extractionBatchKeys.sort((a, b) => {
      return <any>new Date(b.creation_date) - <any>new Date(a.creation_date);
    });
  }

  filterChange(filter, event, indexVal) {
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceWorkBook.filter = JSON.stringify(this.filterValues);
    this.tableData = this.dataSourceWorkBook.filteredData;

  }

  filterChange1(filter, event, indexVal) {
    this.pageIndex = 0;
    this.size = 5;
    this.p1 = 1;
    this.filterValues1[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceConfigWorkBook.filter = JSON.stringify(this.filterValues1);
    this.tableData1 = this.dataSourceConfigWorkBook.filteredData;

  }
  createFilter() {
    const filterFunction = function (data, filter): boolean {
      const searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '' && searchTerms[col].toString().toLowerCase() !== 'none') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }


      const nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          if (data.source_type.toLowerCase() == searchTerms.source_type) {
            found = true;
          }
          else if ((!searchTerms.source_type || searchTerms.source_type == "undefined")) {
            found = true;
          }
          return found;
        } else {
          return true;

        }
      };
      return nameSearch();
    }
    return filterFunction;
  }

  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }

  getFilterObject1(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }




  onSubmit1() {
    const body = this.onConfigSubmit1();
    this.celService.onConfigSubmit(body).subscribe((res) => {
      if (res.Result === 'SUCCESS') {
        this.batchKey = res.Batch_Key;
        this.batchStatus = res.Batch_Status;
        this.celService.batchKey = this.batchKey;
        this.celService.batchStatus = this.batchStatus;
      }
      if (res.Batch_Key) {
        const dialogRef = this.dialog.open(InfoPopupComponent, {
          width: "917px",
          height: "220px",
          data: {
            type: 'Task Status',
            mess: `Batch Key ${res.Batch_Key} :<b> New</b>`,
          }
        });
        dialogRef.afterClosed().subscribe((result) => {
          this.celService.tabval.next("createSubmit");
          this.router.navigate(["./createSubmit"], { relativeTo: this.route });
        });
      } else {
        this.celService.tabval.next("createSubmit");
        this.router.navigate(["./createSubmit"], { relativeTo: this.route });
      }
    },
      (error) => {
        this.notification.showError('Something went wrong!');
      });
  }

  onConfigSubmit1() {
    const body = {
      batchkey: '',
      projectname: this.celService.projId,
      requestedby: this.celService.requestedBy,
      requesttype: DconConfigAPI.API_VARIABLES.Request_Type_ConfigWorkbook,
      filesharepath: this.celService.getfileSharePath(),
      LineItems: this.getLineItems(this.selected),
    };
    return body;
  }

  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.batch_key && element.extract_status) {
        const trackObj = {
          batchkey: element.batch_key,

        };
        data.push(trackObj);
      }
    });
    return data;
  }

  createFilterForWorkbook() {
    const filterFunction = function (data, filter): boolean {
      const searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '' && searchTerms[col].toString().toLowerCase() !== 'none') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      const nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          if (data.workbook_status.toLowerCase() == searchTerms.workbook_status) {
            found = true;
          }
          else if ((!searchTerms.workbook_status || searchTerms.workbook_status == "undefined")) {
            found = true;
          }
          return found;
        } else {
          return true;

        }
      }
      return nameSearch();
    }
    return filterFunction;
  }

  downloadFiles(module, batchKey) {
    let fileList;
    if(Array.isArray(module)) {

      fileList = module.reduce((obj, curr) => {
        // if(curr.application !=='Error' && curr.fileList) {
        if(curr.fileList && curr.fileList.length) {
          obj.push(curr.fileList[0]);
        }
        return obj;
      },[]);
    } else if (module.fileList) {
      fileList = module.fileList;
    }
    if (fileList && fileList.length > 0) {
      this._data.apiCallInProgress = true;
      document.getElementById("overlay").style.display = "block";
      const body = {
        "fileList": fileList
      };

      this.celService.downloadFiles(body).subscribe(res => {
        if (res.byteLength === 1176) {
          this.notification.showError("Failed to download workbook file");
        } else {
          this.writeContents(res, `${batchKey}_WORKBOOK.zip`);
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.hideme = null;

          // dialogRef.close();
        }
      },
        error => {
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.notification.showError("Failed to download workbook file");
        });
    } else {
      this.notification.showError("File not found");
    }
  }



  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  onBatchKeyClick(batchKey, element, type) {
    if (type === 'extracts') {
      this.alertPopUp("Task Status", `Batch Key ${batchKey}: <b>${element.extract_status}</b>`);
    } else if (type === 'workbooks') {
      this.alertPopUp("Task Status", `Batch Key ${batchKey}: <b>${element.workbook_status}</b>`);
    }
  }

  alertPopUp(type, mess) {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: type,
        mess: mess
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if ((result = "ok")) {
        dialogRef.close();
      }
    });
  }

  // check if the item are selected
  checked(item) {
    if (this.selected.indexOf(item) !== -1) {
      return true;
    }
  }

  // when checkbox change, add/remove the item from the array
  onChange(event, item) {
    if (event.checked === true) {
      this.selected.push(item);
      if (this.selected.length >= 0) {
        this.workbookNewBtnDisable = false;
      } else {
        this.workbookNewBtnDisable = true;
      }

    } else {
      this.selected.splice(this.selected.indexOf(item), 1);
      if (this.selected.length <= 0) {
        this.workbookNewBtnDisable = true;
      }

    }
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  getWorkbookCsvPage() {
    this.router.navigate(["./workbookcsv"], { relativeTo: this.route });

  }

  getDownloadDropdown(i) {
    this.hideme = i;
  }

  getRefresh() {
    this.ngOnInit();
    this.hideme = null;
  }

  autoCloseForDropdownCars(event) {
    var target = event.target;
    if (!target.closest(".download-enhancement")) {
      this.hideme = null;
    }
  }

  modulePopUp(batchkey, module) {
    module = module.filter(e => e.application !== 'Error');
    const dialogRef = this.dialog.open(ModulePopupComponent, {
      width: "795px",
      height: "470px",
      data: {
        moduleData: { batchkey: batchkey, module: module },
      },
    });
  }

  paginate(event: any) {
    this.pageIndex = event;
    this.tableData = this.dataSourceWorkBook.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  paginate1(event: any) {
    this.pageIndex = event;
    this.tableData1 = this.dataSourceConfigWorkBook.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  searchOnInput(event) {
    if (event == null || event == undefined || event == '') {
      this.search('');
    }
  }

  searchOnInput1(event) {
    if (event == null || event == undefined || event == '') {
      this.searchForWorkbook('');
    }
  }

}
